<template>
  <div id="productDisplay">
    <div class="poster">
      <img src="@/common/img/img2.ff0f2513.jpg" alt="">
    </div>

    <div class="container">
    </div>

    <div style="width: 1170px;padding: 0 10px; box-sizing: border-box;border-bottom: 1px solid #ececec; line-height: 48px;display: flex;justify-content: center; align-items: center; font-size: 18px;font-weight: 700;">
      <p class="title"> 实验室及仪器</p>
    </div>

    <div class="display-list">
      <div style="max-width: 1170px;display: flex;flex-wrap: wrap;justify-content: center; padding: 10px 5px; box-sizing: border-box;">
          <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
            <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
              <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/2.jpg" alt=""></div>
              <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置1</p>
            </div>
          <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
            <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
              <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/3.jpg" alt=""></div>
              <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置2</p>
          </div>
          <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
            <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
              <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/4.jpg" alt=""></div>
              <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置3</p>
          </div>
          <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
            <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
              <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/5.jpg" alt=""></div>
              <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置4</p>
          </div>
          <div style="display: flex; flex-direction: column; align-items: center; padding: 0 6px 12px 6px;">
            <div style="display: flex; justify-content: center; align-items: center; border: 1px dashed #e4e7ed; box-sizing: border-box;width: 300px; height: 242px;overflow: hidden;">
              <img style="transition: all .5s; width: 70%;" src="@/assets/images/images/6.jpg" alt=""></div>
              <p style="margin: 0; padding: 5px 0;overflow: hidden;text-overflow: ellipsis; white-space: nowrap;font-size: 15px; font-weight: 700;background-color: #fff; text-align: center;width: 300px;">实验装置5</p>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { menuList, proList } from "@/api/product";

export default {
  name: 'index',
  components: {
  },
  data () {
    const baseUrl = process.env.VUE_APP_BASE_API

    return {
      baseUrl: baseUrl,
      menuList: [],
      menuBtnList: [],
      menuBtnChildrenList: [],
      selectedBtn: 0,
      selectedChildrenBtn: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 9,
        proOrSol: '0',
        type: ''
      },
      dataList: [],
      total: 0
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.$store.state.el_.scrollTop = 0
    })
  },
  created() {
    //this.getMenuList()
  },
  methods: {
    queryProList(item, index) {
      this.selectedChildrenBtn = 0
      this.selectedBtn = index || index === 0 ? index : this.selectedBtn
      this.queryParams.pageNum = 1
      this.menuBtnChildrenList = this.menuList.filter(val => {
        return val.pid === item.id
      })

      if (this.menuBtnChildrenList.length > 0) {
        this.queryChildrenProList(this.menuBtnChildrenList[0])
      } else {
        this.queryParams.type = item.name || this.queryParams.type
        proList(this.queryParams).then(res => {
          console.log('产品列表', res)
          this.dataList = res.rows
          this.total = res.total
        })
      }

      // this.queryParams.type = item.name || this.queryParams.type
      // console.log('产品列表参数', this.queryParams)
      // proList(this.queryParams).then(res => {
      //   console.log('产品列表', res)
      //   this.dataList = res.rows
      //   this.total = res.total
      // })
    },

    queryChildrenProList(item, index) {
      this.selectedChildrenBtn = index || index === 0 ? index : this.selectedChildrenBtn
      this.queryParams.type = item.name || this.queryParams.type
      console.log('产品列表参数', this.queryParams)
      proList(this.queryParams).then(res => {
        console.log('产品列表', res)
        this.dataList = res.rows
        this.total = res.total
      })
    },

    getMenuList() {
      menuList().then(res => {
        console.log('menuList', res)
        this.menuList = res.rows
        this.menuBtnList = res.rows.filter(val => {
          return val.pid === '0'
        })
        this.menuBtnChildrenList = res.rows.filter(val => {
          return val.pid === this.menuBtnList[0].id
        })
        if (this.menuBtnChildrenList.length > 0) {
          this.queryChildrenProList(this.menuBtnChildrenList[0])
        } else {
          this.queryChildrenProList(this.menuBtnList[0])
        }
      })
    },

    goDetail(item) {
      this.$router.push({
        path: '/productDetail',
        query: {
          obj: JSON.stringify(item)
        }
      })
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val
      this.queryChildrenProList(this.queryParams)
    }
  }
}
</script>

<style lang='less' scoped>
  @media screen and (max-width: 768px) {
    #productDisplay{
    }
  }

  @media screen and (min-width: 768px) {
    #productDisplay {
    }
  }

  #productDisplay {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .poster {
      width: 100%;

      img {
        width: 100%;
      }
    }

    .container {
      width: 100%;

      .btnContent {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 5px;
        box-sizing: border-box;

        .btnBox1 {
          display: flex;
          align-items: center;

          .el-button {
            font-size: 18px;
          }
        }

        .btnBox2 {
          display: flex;
          align-items: center;

          .el-button {
            font-size: 15px;
          }
        }

        .el-button {
          padding: 10px 0;
          color: black;

          &:hover {
            color: red;
          }
        }
      }
    }
    ul {
      padding: 0;
    }
    .isShow {
      // background-color: rgb(10, 132, 202);
      color: red !important;
    }

    .empty-class {
      color: #e4e4e4;
    }
  }

  @media screen and (min-width: 768px) {
    .display-list {
      max-width: 1170px;
    }

    .classTitle {
      width: 1170px;
    }

    .display-item {
      div {
        width: 300px;
        height: 242px;
        overflow: hidden;
      }

      p {
        width: 300px;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .display-list {
      width: 100%;
    }

    .classTitle {
      width: 100%;

      .title {
        font-size: 20px !important;
        line-height: 20px !important;
        font-weight: bold;
        color: #3b3b3b;
        letter-spacing: 2px;
        margin: 6px 0;
      }
    }

    .display-item {
      div {
        width: 170px;
        height: 140px;
        overflow: hidden;
      }
      p {
        width: 170px;
      }
    }
  }

  .classTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ececec;

    .title {
      font-size: 30px;
      font-weight: bold;
      line-height: 56px;
      color: #3b3b3b;
      letter-spacing: 2px;
      margin: 6px 0;
    }

    .content {
      font-size: 12px;
      color: #a0a0a0;
    }
  }

  .display-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 36px 5px;
    box-sizing: border-box;

    .display-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 6px 12px 6px;

      .imgBox {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #e4e7ed;
        box-sizing: border-box;

        img {
          transition: all .5s;
          width: 70%;
          // height: 100%;

          &:hover {
            transform: scale(1.2);
          }
        }
      }

      p {
        margin: 0;
        padding: 5px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 15px;
        font-weight: bold;
        background-color: #fff;
        text-align: center;
      }

      &:hover {
        cursor: pointer;

        .imgBox {
          border-bottom: none;
          border-color: #3a8ee6;
        }

        p {
          background: #3a8ee6;
          color: #fff;
        }
      }
    }
  }
</style>
